module.exports = __webpack_public_path__ + "img/kaodian.20e054ba.png";